import { concat, keyBy, map, uniq } from "lodash";
import { UserStateType } from "./types";
import { getStorage, hasStorageKey } from "../../libs/storage";
import { STORAGE_MEDIA_SETTING, STORAGE_USER_ID } from "../../constants/localstorage";
import { createReducer } from "@reduxjs/toolkit";
import { addUser, addUserBlocked, addUserContacts, addUsers, deleteUserContacts, getUser, removeUserBlocked, setUserStatus, setUserStorage, updateUser } from "./actions";
import { cloudUserData, FetchingStatus, getCloudAvatar } from "../../constants/globals";

const userStorage = {
  saved_file: hasStorageKey(STORAGE_MEDIA_SETTING, "auto_download") ? getStorage(STORAGE_MEDIA_SETTING)?.saved_file : 1,
  auto_download: hasStorageKey(STORAGE_MEDIA_SETTING, "auto_download") ? getStorage(STORAGE_MEDIA_SETTING)?.auto_download : false,
  auto_play_gif: hasStorageKey(STORAGE_MEDIA_SETTING, "auto_play_gif") ? getStorage(STORAGE_MEDIA_SETTING)?.auto_play_gif : false,
  auto_play_video: hasStorageKey(STORAGE_MEDIA_SETTING, "auto_play_video") ? getStorage(STORAGE_MEDIA_SETTING)?.auto_play_video : false,
};

const initialState: UserStateType = {
  users: {},
  userContacts: [],
  userBlocked: [],
  userStatus: {},
  userAvatar: undefined,
  userStorageSettings: userStorage,
  loading: "idle",
};

export const usersReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getUser, (state, action) => {
      if (!state.users[action.payload.userId]) {
        // @ts-ignore
        state.users[action.payload.userId] = {};
      }
      state.users[action.payload.userId].fetchingStatus = FetchingStatus.Loading;
    })
    .addCase(addUser, (state, action) => {
      if (action.payload.id === getStorage(STORAGE_USER_ID, true)) state.userAvatar = action.payload.avatar;
      state.users[action.payload.id] = { ...action.payload, ...cloudUserData(action.payload), fetchingStatus: FetchingStatus.Resolved };
    })
    .addCase(addUsers, (state, action) => {
      state.users = {
        ...state.users,
        ...keyBy(
          map(action.payload, (user) => ({ ...user, fetchingStatus: FetchingStatus.Resolved })),
          "id"
        ),
      } as UserStateType["users"];
      state.userAvatar = state.users[getStorage(STORAGE_USER_ID)]?.avatar;
    })
    .addCase(updateUser, (state, action) => {
      if (action.payload.userId === getStorage(STORAGE_USER_ID)) {
        state.userAvatar = action.payload.values.avatar;
      }
      state.users[action.payload.userId] = {
        ...state.users[action.payload.userId],
        ...action.payload.values,
      };
    })
    .addCase(addUserContacts, (state, action) => {
      state.userContacts = uniq(concat(state.userContacts, action.payload));
    })
    .addCase(deleteUserContacts, (state, action) => {
      state.userContacts = state.userContacts.filter((memberId) => memberId !== action.payload);
    })
    .addCase(addUserBlocked, (state, action) => {
      state.userBlocked = uniq(concat(state.userBlocked, action.payload));
    })
    .addCase(removeUserBlocked, (state, action) => {
      state.userBlocked = state.userBlocked.filter((userId) => userId !== action.payload);
    })
    .addCase(setUserStatus, (state, action) => {
      state.userStatus = {
        ...state.userStatus,
        ...action.payload,
      };
    })
    .addCase(setUserStorage, (state, action) => {
      state.userStorageSettings = {
        ...state.userStorageSettings,
        ...action.payload,
      };
    });
});
